<template>
  <header class="topbar">
    <Button
      type="button"
      icon="pi pi-bars"
      severity="secondary"
      variant="text"
      rounded
      class="topbar__hamburger"
      :aria-label="sidebarOpen ? 'Close navigation' : 'Open navigation'"
      @click="emit('toggle-sidebar')"
    />

    <!-- Logo: host may override via #logo; default is the AutoAuction wordmark. -->
    <span class="topbar__logo">
      <slot name="logo">
        <span class="aa-logo">
          <span class="aa-logo__auto">Auto</span><span class="aa-logo__auction">Auction</span><span class="aa-logo__tld">.com</span>
        </span>
      </slot>
    </span>

    <span class="topbar__spacer" />

    <!-- The house the person stands in. The layout passes houses only for a
         context that is not platform-level, so an empty list means no control. -->
    <HouseSwitcher
      v-if="houses.length > 0"
      :houses="houses"
      :house="house"
      @select-house="(code) => emit('select-house', code)"
    />

    <AvatarMenu />
  </header>
</template>

<script setup>
import { AvatarMenu } from '@hds/common-ui-lib/desktop'
import Button from 'primevue/button'
import HouseSwitcher from './HouseSwitcher.vue'

// Trimmed from vibe-portal's TopBar, and both things it lost are back: the
// auction-house switcher, because the Auction Operations context stands inside
// a house, and the avatar, because the app has a login now. The avatar is the
// shared shell's Avatar Menu: it opens the App Menu, which holds the profile,
// the settings (theme and language) and Log Out. It takes nothing from here —
// who is signed in comes from the session.
defineProps({
  sidebarOpen: { type: Boolean, default: true },
  houses: { type: Array, default: () => [] },
  house: { type: String, default: '' },
})
const emit = defineEmits(['toggle-sidebar', 'select-house'])
</script>

<style scoped>
.topbar {
  height: 56px;
  flex-shrink: 0;
  position: relative;
  z-index: 300;
  background: var(--p-content-background);
  border-bottom: 1px solid var(--p-content-border-color);
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;
}

.topbar__hamburger {
  flex-shrink: 0;
}

.topbar__logo {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  color: var(--p-text-color);
}

.topbar__spacer {
  flex: 1;
}

/* Logo fallback styling (host may supply its own via #logo). */
.aa-logo {
  font-family: var(--p-font-body);
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: -0.02em;
  white-space: nowrap;
  line-height: 1;
  display: inline-flex;
  align-items: baseline;
  user-select: none;
}
.aa-logo__auto {
  color: var(--p-text-color);
}
.aa-logo__auction {
  color: var(--p-primary-color);
}
.aa-logo__tld {
  color: var(--p-surface-400);
  font-size: 0.45em;
  margin-left: 0.05em;
}
</style>
